import React, {FC} from 'react';
import styled, {css} from 'styled-components';
import {LiveShoppingEvent} from '../../../../../grpc_client/grips/protos/shared/live_shopping_event';
import {mediaMinTablet} from '../../../../../ui/constants/customMedia';
import {LiveEvent} from '../LiveEvent/LiveEvent';

export const LiveSectionEvents: FC<{
  events: LiveShoppingEvent[];
  eventsHaveEnded: boolean;
}> = ({events, ...props}) => {
  if (events.length === 0) {
    return null;
  }

  return (
    <StyledArticle {...props}>
      {events.map(event => (
        <LiveEvent
          key={event.id}
          event={event}
          data-testid={`LiveShoppingEvent-${event.id}`}
        />
      ))}
    </StyledArticle>
  );
};

const StyledArticle = styled.article<{eventsHaveEnded: boolean}>`
  ${props =>
    props.eventsHaveEnded
      ? css`
          @media ${mediaMinTablet} {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            padding: 0 10px;
          }
        `
      : ''}
`;
